import { Buildings } from "@phosphor-icons/react";
import { SettingsCrud } from "./SettingsCrud";
import { TIMEZONE_OPTIONS } from "../../lib/timezones";

export function BranchesSettings() {
  return (
    <SettingsCrud
      testid="branches"
      title="Branches"
      singular="Branch"
      icon={Buildings}
      description="Physical locations or offices in your organization. Assign users to a branch."
      endpoint="/branches"
      meta={(b) => (b.user_count ? `${b.user_count} user${b.user_count > 1 ? "s" : ""}` : "")}
      subtitle={(b) => [b.code, b.timezone, b.address].filter(Boolean).join(" · ")}
      fields={[
        { name: "name", label: "Branch name", type: "text", required: true, placeholder: "e.g. Downtown Office" },
        { name: "code", label: "Code", type: "text", placeholder: "e.g. DT" },
        { name: "timezone", label: "Time zone", type: "select", options: TIMEZONE_OPTIONS, allowEmpty: true, emptyLabel: "Use organization default", placeholder: "Select time zone…" },
        { name: "address", label: "Address", type: "text", placeholder: "Street, City" },
      ]}
    />
  );
}

export default BranchesSettings;
